/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import get from "lodash/get";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import React from "react";
import { SocialFollow } from "../../basic/social-follow/social-follow";
import { CustomLink } from "../../custom-link";
import "./footer-template-two/footer-two.module.css";
import { Menu } from "./menu";
import { getTextContrast } from "../../../utils";
import canUseDOM from "../../../../utils/can-use-dom";

function getMenuData(menu, menuGroup, domainSlug) {
  const filteredMenu = domainSlug
    ? menu.filter(item => item["menu-group-slug"] === `footer-menu-${domainSlug}`)
    : menu.filter(item => item["menu-group-slug"] === menuGroup);
  return filteredMenu;
}

export const SocialFollowWrapper = props => {
  const { socialFollowStyle, socialLinks, publisherTheme, customCssClasses = "", footerPageBuilderConfig = {} } = props;
  const textContrast = getTextContrast(get(footerPageBuilderConfig, ["backgroundColor"]));
  return (
    <SocialFollow
      hasBackground={true}
      contrastAgainstBg={textContrast}
      socialStyle={socialFollowStyle}
      socialLinks={socialLinks}
      color={publisherTheme["footer-text-color"] || "#000"}
      customCssClasses={customCssClasses}
    />
  );
};
SocialFollowWrapper.propTypes = {
  socialLinks: PropTypes.object,
  customCssClasses: PropTypes.string,
  publisherTheme: PropTypes.object,
  footerPageBuilderConfig: PropTypes.object,
  socialStyle: PropTypes.string,
  socialFollowStyle: PropTypes.string
};

export const SubscribeButton = props => {
  const { enableAccesstype } = props;
  return (
    enableAccesstype && (
      <a href="/subscription">
        <button styleName="subscribe-button" data-test-id="footer-subscribe">
          Subscribe
        </button>
      </a>
    )
  );
};

SubscribeButton.propTypes = {
  enableAccesstype: PropTypes.bool
};

export const Monogram = props => {
  const footerLogoUrl = get(props, ["footerLogoUrl"], "");
  const sketchesHost = useSelector(state => get(state, ["qt", "config", "sketches-host"], "/"));
  const logoUrl = useSelector(state => get(state, ["qt", "config", "theme-attributes", "logo_url"], sketchesHost));
  return (
    canUseDOM && (
      <div id="monogram">
        {
          <CustomLink href={logoUrl}>
            {footerLogoUrl ? (
              <img styleName="logo" src={footerLogoUrl} alt={props.publisherName} loading="lazy" />
            ) : (
              <img styleName="logo" loading="lazy" />
            )}
          </CustomLink>
        }
      </div>
    )
  );
};
Monogram.propTypes = {
  publisherName: PropTypes.string
};

export const DefaultMenu = ({ menu, domainSlug, publisherTheme, closeAll, customCssClasses = "" }) => (
  <Menu
    styleName="menu"
    menu={getMenuData(menu, "footer-site-links", domainSlug)}
    languageDirection={get(publisherTheme, ["language_direction"], "left")}
    count={publisherTheme["primary_menu_count"] || 6}
    closeAll={closeAll}
    customCssClasses={customCssClasses}
  />
);
DefaultMenu.propTypes = {
  menu: PropTypes.array,
  domainSlug: PropTypes.string,
  closeAll: PropTypes.func,
  customCssClasses: PropTypes.string,
  publisherTheme: PropTypes.object,
  publisherName: PropTypes.string
};
